interface IconProps extends React.SVGProps<SVGSVGElement> {}

export const GeneralBackofficeLogo = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 566.9 566.9"
    fill="none"
    {...props}
  >
    <rect
      x="32.9"
      y="33.5"
      width="500.8"
      height="500"
      rx="50"
      ry="50"
    />
    <path
      fill="#fff"
      d="M476.4,283.2c-7.9,0-14.8,4.2-18.6,10.5c0,0.1-0.1,0.3-0.2,0.4h-12.2c-7.6,0-13.8-6.2-13.8-13.8v-49.8
        c0-24.3-18.3-44-40.8-44s-40.7,19.8-40.7,44v59.7c-6.5,3.8-10.9,10.8-10.9,18.8s4.4,15,10.8,18.8v69.5c0,12.1-8.4,22-18.7,22
        s-18.7-9.9-18.7-22v-18.6c3.2-1.8,5.9-4.4,7.8-7.5c2.1-3.3,3.3-7.3,3.3-11.4s-1.2-8.1-3.3-11.4c-1.9-3.1-4.6-5.8-7.8-7.6V188.4
        c0-24.3-18.3-44-40.7-44s-40.7,19.8-40.7,44v118.7c-6.5,3.8-10.9,10.8-10.9,18.8s4.4,15,10.9,18.8v20.8c0,12.1-8.4,22-18.7,22
        s-18.7-9.9-18.7-22v-66.4c3.1-1.8,5.8-4.4,7.7-7.5c2.1-3.3,3.3-7.3,3.3-11.4s-1.2-8.1-3.3-11.4c-1.9-3.1-4.5-5.7-7.7-7.5v-13.9
        c-0.9-23.8-18.7-42.4-40.7-42.4s-40.8,19.8-40.8,44v49.5c0,5-2.7,9.5-6.6,11.9c-3.9-3.9-9.4-6.4-15.4-6.4
        c-12.1,0-21.9,9.8-21.9,21.9s9.8,21.9,21.9,21.9c7.2,0,14.8-4.2,18.6-10.4c1-1.6,1.8-3.4,2.4-5.3c13.5-5.2,23-18.3,23-33.6v-49.5
        c0-12.1,8.4-22,18.7-22s18.7,9.9,18.7,22v12.4c-6.5,3.8-10.9,10.8-10.9,18.8s4.4,15,10.9,18.8v66.6c0,24.3,18.3,44,40.7,44
        s40.7-19.8,40.7-44v-20.7c3.1-1.8,5.8-4.4,7.6-7.5c2.1-3.3,3.3-7.3,3.3-11.4s-1.2-8.1-3.3-11.4c-1.9-3.1-4.5-5.7-7.6-7.5V188.4
        c0-12.1,8.4-22,18.7-22s18.7,9.9,18.7,22v171c-6.4,3.8-10.8,10.8-10.8,18.8s4.4,14.9,10.8,18.7v18.9c0,24.3,18.3,44,40.7,44
        s40.7-19.8,40.7-44v-69.4c3.1-1.8,5.8-4.4,7.7-7.5c2.1-3.3,3.3-7.3,3.3-11.4s-1.2-8.1-3.3-11.4c-1.9-3.1-4.5-5.7-7.7-7.5v-59.6
        c0-12.1,8.4-22,18.7-22s18.7,9.9,18.7,22v55.7c0,16.5,13.4,29.9,29.9,29.9h18.1c0,0.1,0.1,0.3,0.2,0.4c3.8,6.3,10.8,10.4,18.6,10.4
        c12.1,0,21.9-9.8,21.9-21.9S488.5,283.2,476.4,283.2z"
    />
  </svg>
);
